import companyInfo from './company'
import common from './common'
import find from './find'
import agreement from './agreement'
import personal from './personal'
import form from './form'
import footprint from './footprint'
import live from './live'
import home from './home'
import invite from './invite'
import login from './login'
import login2 from './login2'
import employee from './employee'
import selectFields from './selectFields'
import aboutus from './aboutus'
import hm from './hm'
import vip from './vip'
import groupPreRegistration from './groupPreRegistration'
import buttons from './buttons'
import version from './version'
import clientPool from './clientPool'
import qa from './qa'

import procurement from './procurement'
import online from './online'

export default {
  companyInfo: {
    ...companyInfo
  },
  common: {
    ...common
  },
  finds: {
    ...find
  },
  agreement: {
    ...agreement
  },
  personal: {
    ...personal
  },
  ...form,
  footprints: {
    ...footprint
  },
  lives: {
    ...live
  },
  homes: {
    ...home
  },
  invites: {
    ...invite
  },
  logins:{
    ...login
  },
  login2s:{
    ...login2
  },
  employee:{
    ...employee
  },
  select: {
    ...selectFields
  },
  aboutus2: {
    ...aboutus
  },
  ...hm,
  hm: {
    ...hm,
  },
  version: {
    ...version
  },
  vip: {
    ...vip
  },
  gPreReg: {
    ...groupPreRegistration
  },
  buttons: {
    ...buttons
  },
  clientPool: {
    ...clientPool
  },
  qa: {
    ...qa
  },
  online: {
    ...online
  },
  procurement: {
    ...procurement
  }
}